<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="rangeInfoDialogVisible"
      :title="codeTitle"
      top="10vh"
      width="800px"
      @close="clearForm"
    >
      <div v-if="isModify" class="tip01">
        {{ $t('collectionCenter.tips') }}：{{ $t('collectionCenter.startPostcodeCannotExceedEnd') }}
      </div>
      <el-form
        v-if="isModify"
        ref="rangeInfoFormRef"
        :model="rangeInfoForm"
        class="demo-rangeInfoForm"
        label-position="top"
      >
        <el-form-item
          :rules="{
            required: true,
            message: $t('placeOrder.pleaseInput'),
            trigger: ['blur', 'change']
          }"
          :label="$t('collectionCenter.pastePostcode')"
          prop="zipCodeValue"
          style="width: 100%"
        >
          <el-input
            v-model.trim="rangeInfoForm.zipCodeValue"
            clearable
            :placeholder="$t('collectionCenter.postcodeFormatInstructions')"
            rows="5"
            type="textarea"
            @input="handleZipCodeValueChange"
            @blur="zipCodeFil"
          />
        </el-form-item>
      </el-form>
      <div v-if="isModify" style="text-align: left; margin-bottom: 15px">
        <el-button size="small" type="primary" @click="addForm">{{ $t('GlobalSetObj.append') }}</el-button>
        <el-button size="small" type="danger" @click="deleteAll">{{ $t('collectionCenter.DeleteAll') }}</el-button>
      </div>
      <div v-if="showProgress" style="margin-bottom: 20px;">
        <span v-if="!showResultDetails">
          <span style="color: #4f504f;font-size: 14px">
            {{ $t('collectionCenter.systemExecutingTask') }}
          </span>
          <el-progress
            :percentage="uploadProgress"
            :stroke-width="10"
            style="margin: 5px 0 10px;"
          />
        </span>
        <div v-else>
          <span style="color: #4f504f;font-size: 14px">
            {{ $t('collectionCenter.taskCompletedCheckResult') }}
          </span>
          <el-progress
            percentage="100"
            :stroke-width="10"
            style="margin: 5px 0 10px;"
          />
          <div v-if="errorData && errorData.length > 0" style="color: red">
            <span>{{ $t('collectionCenter.importFailedPostcodes') }}</span><br>
            <div v-for="(item, index) in errorData" :key="index">
              {{ index + 1 }}. {{ item.errorRange }}，{{ item.errorMessage }}
            </div>
          </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
        :fit="true"
      >
        <el-table-column
          :label="$t('collectionCenter.ind')" width="80" type="index"
          align="center"
        />
        <el-table-column :label="$t('collectionCenter.startZipCode')" prop="startZip" align="center" />
        <el-table-column :label="$t('collectionCenter.endZipCode')" prop="endZip" align="center" />
        <el-table-column
          v-if="isModify" :label="$t('collectionCenter.operation')" width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-popconfirm
              :title="$t('collectionCenter.deleteSure')"
              @confirm="delRow(scope.$index)"
            ><!-- 确定删除吗？ -->
              <div slot="reference" style="color: #1d90ff; font-size: 14px; cursor: pointer">
                {{ $t('collectionCenter.Delete') }}
              </div><!-- 删除 -->
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="isModify" style="text-align: center; margin: 15px 0">
        <el-button size="small" @click="clearForm">{{ $t('GlobalSetObj.Close') }}</el-button>
        <el-button size="small" type="primary" @click="saveForm">{{ $t('collectionCenter.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  validateZipCodeRange
} from '@/api/finance/basicData';
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0
      },
      rangeInfoDialogVisible: false,
      rangeInfoForm: {
        NumberType: '',
        zipCodeValue: ''
      },
      tableData: [],
      codeTitle: '',
      showProgress: false,
      uploadProgress: 0,
      showResultDetails: false,
      businessType: null,
      errorData: [],
      isModify: false
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
  },
  methods: {
    // 过滤非法字符
    handleZipCodeValueChange(val) {
      console.log(val, '1232');
      // 正则匹配：数字(\d)、~、,、换行(\n)，替换其他字符为空
      this.rangeInfoForm.zipCodeValue = val.replace(/[^\d~,\n]/g, '');
      console.log(this.rangeInfoForm.zipCodeValue, 'this.rangeInfoForm.zipCodeValue');
    },
    // 过滤空行
    zipCodeFil() {
      const currentValue = this.rangeInfoForm.zipCodeValue;
      const lines = currentValue.split('\n').flatMap(line => line.split(',')).filter(item => item.trim() !== '');
      const processedLines = lines.map(line => {
        if (line.includes('~')) {
          const [start, end] = line.split('~');
          if (!end || end.trim() === '') {
            if (start && /^\d{8}$/.test(start)) {
              return start;
            } else {
              return '';
            }
          }
          if (start && end && /^\d{8}$/.test(start) && /^\d{8}$/.test(end)) {
            return `${start}~${end}`;
          } else {
            return '';
          }
        } else {
          if (/^\d{8}$/.test(line)) {
            return line;
          } else {
            return '';
          }
        }
      }).filter(part => part !== '');
      this.rangeInfoForm.zipCodeValue = processedLines.join(',');
      console.log(this.rangeInfoForm.zipCodeValue, ' <=======最终输入邮编');
    },
    readDialog(title, rangeVal) {
      // 处理查看状态
      this.codeTitle = title;
      this.isModify = false;
      this.both(rangeVal);
    },
    // 添加
    showDialog(val, type, rangeVal) {
      // (2, "小件揽收"),(3, "小件派送"),(4, "大件派送"),(5, "大件揽收");
      this.businessType = type;
      this.codeTitle = val;
      this.isModify = true;
      this.both(rangeVal);
    },
    both(rangeVal) {
      this.rangeInfoDialogVisible = true;
      if (rangeVal && typeof rangeVal === 'string' && rangeVal.trim() !== '') {
        const ranges = rangeVal.split(',');
        const parsedData = [];
        ranges.forEach(range => {
          if (range.includes('~')) {
            const [startZip, endZip] = range.split('~');
            parsedData.push({
              startZip,
              endZip
            });
          } else {
            parsedData.push({
              startZip: range,
              endZip: range
            });
          }
        });
        this.tableData = [...parsedData]; // 替换或追加到现有数据
      }
    },
    delRow(index) {
      this.tableData.splice(index, 1);
    },
    // 删除全部
    deleteAll() {
      this.tableData = [];
    },
    // 关闭
    clearForm() {
      this.$nextTick(() => {
        if (this.$refs['rangeInfoFormRef']) {
          this.$refs['rangeInfoFormRef'].resetFields();
        }
      });
      this.rangeInfoDialogVisible = false;
      this.showProgress = false;
      this.showResultDetails = false;
      this.uploadProgress = 0;
      this.errorData = []; // 清空报错信息
      this.tableData = [];
    },
    // 邮编范围添加
    async addForm() {
      this.errorData = []; // 清空报错信息
      const valid = await this.$refs['rangeInfoFormRef'].validate();
      if (valid) {
        this.showProgress = false;
        this.showResultDetails = false;
        this.uploadProgress = 0;
        // 检查输入值
        if (!this.validateZipCode(this.rangeInfoForm.zipCodeValue)) return;
        // 检查重复
        if (!this.checkDuplicateWithTableData(this.rangeInfoForm.zipCodeValue)) return;
        // 显示进度条
        this.showProgress = true;
        this.showResultDetails = false;
        this.uploadProgress = 0;
        // 模拟进度更新
        const interval = setInterval(() => {
          if (this.uploadProgress < 90) {
            this.uploadProgress += 5;
          } else {
            clearInterval(interval);
          }
        }, 200);
        const formData = {
          zipCodeRange: this.rangeInfoForm.zipCodeValue,
          businessType: this.businessType
        };
        validateZipCodeRange(formData).then(res => {
          if (res.code === 200) {
            /**
             * 接口返回后，设置this.uploadProgress = 100;
             * 请求失败时，this.uploadProgress = 0;
             */
            this.uploadProgress = 100;
            this.showResultDetails = true;
            if (res.data.success) {
              const tableData = res.data.validZipRanges.map((item, inx) => {
                return {
                  ...item
                };
              });
              this.tableData.unshift(...tableData);
              this.$message.success(res.data.message);
            } else {
              this.errorData = res.data.errorDetails;
              this.$message.error(res.data.message);
            }
          } else {
            this.uploadProgress = 0;
          }
        }).catch(() => {
          this.uploadProgress = 0;
        });
      }
    },
    // 提交保存
    async saveForm() {
      console.log(this.ruleForm, '===ruleForm');
      if (this.ruleForm.siteStatus !== 0) {
        if (this.tableData && this.tableData.length) {
          const zipCodeRanges = this.tableData.map(item => {
            if (item.startZip === item.endZip) {
              return item.startZip;
            }
            return `${item.startZip}~${item.endZip}`;
          }).join(',');
          this.$emit('childrenData', zipCodeRanges, this.businessType);
          this.clearForm();
        } else {
          this.$message.error(this.$t('operatingPlatform.noData'));
        }
      } else {
        if (this.tableData && this.tableData.length) {
          const zipCodeRanges = this.tableData.map(item => {
            if (item.startZip === item.endZip) {
              return item.startZip;
            }
            return `${item.startZip}~${item.endZip}`;
          }).join(',');
          this.$emit('childrenData', zipCodeRanges, this.businessType);
          this.clearForm();
        } else {
          this.$emit('childrenData', null, this.businessType);
          this.clearForm();
        }
      }
    },
    /**
     * 校验邮编范围值
     */
    validateZipCode(value) {
      const zipcodeSegments = value.split(',');
      const codeVal = []; // 存放所有邮编，去重检查
      let greaterThan = false; // 是否存在起始邮编大于结束邮编的情况
      for (const segment of zipcodeSegments) {
        if (segment.includes('~')) {
          // 处理区间邮编格式：如 1000000~22222222
          const [start, end] = segment.split('~');
          // 检查是否为8位数字
          if (!/^\d{8}$/.test(start) || !/^\d{8}$/.test(end)) {
            this.$message.warning(this.$t('collectionCenter.format1'));
            return false;
          }
          // 检查起始邮编不能大于结束邮编
          if (parseInt(start) > parseInt(end)) {
            greaterThan = true;
          }
          codeVal.push(start, end);
        } else {
          // 处理单个邮编格式：如 30000000
          if (!/^\d{8}$/.test(segment)) {
            this.$message.warning(this.$t('collectionCenter.format1'));
            return false;
          }
          codeVal.push(segment);
        }
      }
      const indexVal = this.useIndexOf(codeVal);
      if (new Set(codeVal).size !== codeVal.length) {
        this.$message.warning(
          this.$t('collectionCenter.noDuplicationAllowed') +
          '，' +
          this.$t('collectionCenter.repeat') +
          indexVal
        );
        return false;
      }
      if (greaterThan) {
        this.$message.warning(this.$t('collectionCenter.zipCodeRangeSizePrompts'));
        return false;
      }
      return true;
    },
    useIndexOf(Arr) {
      const len = Arr.length;
      const result = [];
      for (let i = 0; i < len; i++) {
        const curNum = Arr[i];
        // 遍历到Arr[i]时，若在这个索引i之后都没找到相同数字，则indexOf会返回-1，说明该数字不存在重复
        if (Arr.indexOf(curNum, i + 1) !== -1) {
          result.push(curNum);
        }
      }
      return Array.from(new Set(result));
    },
    /**
     * 校验邮编与表格重复值
     */
    checkDuplicateWithTableData(value) {
      const zipcodeSegments = value.split(',');
      const duplicateMessages = []; // 存放重复邮编，提示用
      for (const segment of zipcodeSegments) {
        if (segment.includes('~')) {
          const [start, end] = segment.split('~');
          // 检查是否与表格中的数据重复
          for (const row of this.tableData) {
            // 情况1: 输入的是范围，表格中是单个邮编（在范围内）
            if (row.startZip === row.endZip &&
              parseInt(row.startZip) >= parseInt(start) &&
              parseInt(row.startZip) <= parseInt(end)) {
              duplicateMessages.push(`${row.startZip}`);
            }
            // 情况2: 输入的是范围，表格中也是范围（有重叠）
            if (row.startZip !== row.endZip) {
              // 两个区间有重叠的条件：start <= row.endZip && end >= row.startZip
              if (parseInt(start) <= parseInt(row.endZip) && parseInt(end) >= parseInt(row.startZip)) {
                duplicateMessages.push(`${row.startZip}~${row.endZip}`);
              }
            }
          }
        } else {
          // 处理单个邮编格式：如 30000000
          for (const row of this.tableData) {
            // 情况1: 输入的是单个邮编，表格中是范围（在范围内）
            if (row.startZip !== row.endZip &&
              parseInt(segment) >= parseInt(row.startZip) &&
              parseInt(segment) <= parseInt(row.endZip)) {
              duplicateMessages.push(`${row.startZip}~${row.endZip}`);
            }
            // 情况2: 输入的是单个邮编，表格中也是单个邮编（完全相同）
            if (row.startZip === row.endZip && row.startZip === segment) {
              duplicateMessages.push(`${segment}`);
            }
          }
        }
      }
      if (duplicateMessages.length > 0) {
        const combinedMessage = duplicateMessages.join('，');
        this.$message.warning(`
          ${this.$t('collectionCenter.duplicateValuesExist')}：
          ${combinedMessage}
          ${this.$t('collectionCenter.pleaseReenter')}
        `);
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
.tip01 {
  background-color: #e6f1fe;
  color: #409eff;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 10px;
}
</style>
